import ClearDiscount from "./clearDiscount";

export default ClearDiscount;
